import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-channel-selection-field',
    templateUrl: './channel-selection-field.component.html',
    styleUrls: ['./channel-selection-field.component.scss']
})
export class ChannelSelectionFieldComponent {
    @Input() control!: FormControl;
    @Input() channels: any[] = [];
    @Input() scheduleChannels: any[] = [];
    @Input() disabledChannelIds: number[] = [];

    @Input() disabled = false;
    @Input() customStyle: { [key: string]: string } | null = null;
    @Input() customClass: string | string[] | Set<string> | { [klass: string]: any } = '';
    @Input() previewMode = false;
    @Output() selectionChange = new EventEmitter<any[]>();
    @Output() toggleAll = new EventEmitter<void>();
    @Output() remove = new EventEmitter<number>();

    areAllSelected(): boolean {
        const selected = this.control.value || [];
        const availableChannels = this.channels.filter(
            channel => !this.disabledChannelIds.includes(channel.idChannel)
        );
        return selected.length === availableChannels.length && availableChannels.length > 0;
    }

    isChannelDisabled(channel: any): boolean {
        return this.disabledChannelIds.includes(channel.idChannel);
    }

    onSelectionChange(event: any) {
        this.selectionChange.emit(event.value);
    }

    onRemove(index: number) {
        if (!this.disabled && !this.previewMode) {
            this.remove.emit(index);
        }
    }

    onToggleAll() {
        this.toggleAll.emit();
    }
}
